import api from "PFCore/api";
import { Profile } from "PFTypes";

export const fetchUser = (id: string): Promise<Profile> => api({ url: `admin/users/${id}`, apiVersion: 1 });
